import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { smallShadow } from 'ui/theme/shadows';
import { pxToRem } from 'utils/convert';
import { DRAWER_SIZES } from './constants';
import { DrawSize } from './types';

export const SIZE_WIDTHS = {
  [DRAWER_SIZES.XLARGE]: `calc(100vw - ${spacing.x4})`,
  [DRAWER_SIZES.LARGE]: pxToRem(928),
  [DRAWER_SIZES.MEDIUM]: pxToRem(672),
  [DRAWER_SIZES.SMALL]: pxToRem(525),
};

const HEADER_HEIGHT = 60;
const FOOTER_HEIGHT = 60;

const getDrawWidth = (size: DrawSize): string => {
  if (typeof size === 'number') return pxToRem(size);
  return SIZE_WIDTHS[size] || size;
};

export const StyledBody = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${({ noPadding }) => (noPadding ? '0' : `${spacing.plusHalf} ${spacing.base}`)};
`;

export const StyledDrawer = styled.div<{ size: DrawSize }>`
  align-items: stretch;
  background-color: ${colors.white};
  box-shadow: ${smallShadow.boxShadow};
  display: flex;
  flex-direction: column;
  height: inherit;
  width: ${({ size }) => getDrawWidth(size)};
`;

export const StyledFooter = styled.div<{ alignRight?: boolean }>`
  border-top: ${spacing.single} solid ${colors.grey15};
  display: flex;
  flex: 0 0 ${pxToRem(FOOTER_HEIGHT)};
  padding: ${spacing.half};
  flex-direction: ${({ alignRight }) => (alignRight ? 'row-reverse' : 'row')};
  
  > :not(:first-child) {
    margin-left: ${spacing.half};
  }
`;

export const StyledHeader = styled.div`
  align-items: center;
  border-bottom: ${spacing.single} solid ${colors.grey15};
  display: flex;
  flex: 0 0 ${pxToRem(HEADER_HEIGHT)};
  justify-content: space-between;
  padding: ${spacing.half};
`;
